<template>
  <div :class="clases ? 'dashboard__options--container single_container' : ''">
    <v-menu
      v-model="menu"
      :nudge-bottom="10"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <div
          v-on="on"
          :class="
            solid
              ? 'dashboard__options--input with_box_shadow'
              : 'faccess_datepicker'
          "
          :style="{ 'margin-right': width == '100%' ? '0px' : '10px' }"
        >
          <p>{{ date_text_first }}</p>
          <img
            v-if="menu"
            src="@/assets/img/arrow-down-solid.svg"
            style="transform: rotate(180deg); top: 30%; right: 10px"
          />
          <img v-else src="@/assets/img/arrow-down-solid.svg" />
        </div>
      </template>
      <v-date-picker v-model="date" @change="selectDate" no-title scrollable @keypress="alert('hola')">
      </v-date-picker>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: {
    date_text: {
      type: String,
      default: "dd/mm/aaaa",
    },
    solid: {
      type: Boolean,
      default: true,
    },
    clases: {
      type: Boolean,
      default: true,
    },
    width: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    date: new Date().toISOString().substr(0, 10),
    menu: false,
    date_text_first: "dd/mm/aaaa",
    datePickerFirstClick: false,
    hasAlreadyFilter: false,
    filterSearchedDate: new Date().toISOString().substr(0, 10),
  }),
  mounted() {
    this.date_text_first = this.date_text;
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },
  watch: {
    date(val) {
      this.dateFormatted = this.formatDate(this.date);
      this.date_text_first = this.formatDate(this.date);
      this.filterQuery();
    },
  },
  methods: {
    selectDate(date) {
      this.dateFormatted = this.formatDate(date);
      this.date_text_first = this.formatDate(date);
      this.filterQuery();
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    filterQuery() {
      let vm = this;
      vm.$emit("filterQuery", vm.date_text_first);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/shared/SingleDatePicker.vue